import React, { useState } from 'react'
import "./contact.css"
import './landingpage.css'
import { MdClose } from "react-icons/md";
import contact_boy from "../assets/Landing_page/contact_boy.png"
import thank_you_boy from "../assets/Landing_page/thank_you_boy.png"
import { toast } from 'react-toastify'
import axios from 'axios'

import { API } from './constant';

const Contact = () => {

    const [name, setname] = useState("")
    const [email, setemail] = useState("")
    const [phone, setphone] = useState("")
    const [schoolCollege, setschoolCollege] = useState("")
    const [location, setlocation] = useState("")
    const [message, setmessage] = useState("")

    // thank you modal start 
    const [thankYouModal, setthankYouModal] = useState(false)
    // thank you modal end



    const clearFields = () => {
        setname("")
        setemail("")
        setphone("")
        setschoolCollege("")
        setlocation("")
        setmessage("")
    }

    const handleSubmit = async () => {
        const data = {
            name: name,
            email: email,
            phone: phone,
            school_college: schoolCollege,
            location: location,
            message: message
        }
        await axios.post(`${API}/contact-us/create`, data)
            .then((res) => {
                console.log(res.data)
                clearFields()
                // toast.success(res.data.message)
                setthankYouModal(true)
            })
            .catch((error) => {
                console.log(error)
                toast.warning(error.response.data.message)
            })
    }


    return (
        <div>
            <div id='contact-us' className=''>
                <div className='FJCIC'>
                    <h2 className=' text-main_color font-[400] text-[44px] from-neutral-50 mt-[20px]'>Contact Us</h2>
                </div>

                <div className='form_container FJCIC px-[20px] mx-auto flex-wrap w-full mb-[250px]' >


                    <div className='left_form_fields w-full xl:w-[28%] flex items-center'>
                        <div>
                            <input value={name} onChange={(e) => setname(e.target.value)} className='input_border' type="text" placeholder='Full Name*' />
                        </div>
                        <div>
                            <input value={email} onChange={(e) => setemail(e.target.value)} className='input_border' type="email" placeholder='E-mail*' />
                        </div>
                        <div>
                            <input value={phone} onChange={(e) => setphone(e.target.value)} className='input_border' type="number" placeholder='Mobile Number*' />
                        </div>
                        <div>
                            <input value={schoolCollege} onChange={(e) => setschoolCollege(e.target.value)} className='input_border' type="text" placeholder='School/College*' />
                        </div>
                        <div>
                            <input value={location} onChange={(e) => setlocation(e.target.value)} className='input_border' type="text" placeholder='Location*' />
                        </div>

                    </div>

                    <div className='center_form_fields FJCIC w-full xl:w-[28%]'>

                        <div className='w-[90%]'>
                            <textarea value={message} onChange={(e) => setmessage(e.target.value)} className='input_border resize-none' rows={10} placeholder='Write your Message Here *'></textarea>
                        </div>
                        <div className='w-[90%] mt-[10px]'>
                            <button onClick={handleSubmit} className='button_red w-full'>Submit</button>
                        </div>
                    </div>

                    <div className='right_form_img FJCIC w-[28%] '>
                        {/* <div className='w-[90%]'>
                            <img className='w-full' src={contact_boy} alt="contact boy image" />
                        </div> */}
                    </div>

                </div>
            </div>

            {
                thankYouModal && (
                    <div className='inset-0 fixed  z-50 w-full  bg-black/80 h-full'>
                        <div className='w-full flex justify-between '>
                            <div></div>
                            <div><MdClose onClick={() => setthankYouModal(false)} size={40} color='white' /></div>
                        </div>
                        <div className='flex justify-center h-full items-center'>
                            <div className='h-[60vh] xl:h-[60vh] w-[90%] lg:w-[80%] bg-main_color rounded-lg xl:rounded-[40px] relative overflow-hidden  mt-[0px]  text-center md:text-start'>
                                <div className='flex justify-around xl:items-center h-full  flex-wrap'>
                                    <div className='w-[95%] lg:w-[40%] my-[30px] xl:my-[60px]'>
                                        <div className='text-white_color'>
                                            <h2 className='text-[30px] xl:text-[45px]'>Thank you for </h2>
                                            <h2 className='text-[30px] xl:text-[45px]'>Reaching out!</h2>

                                            <div className='my-[20px] w-full  2xl:w-[80%]'>
                                                <p className='text-[12px] md:text-[15px]'>
                                                    Thank you for reaching out to us!
                                                    Your message has been successfully received.
                                                    Our team will review your enquiry and get back to you shortly.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className=''>
                                        <div className='w-full xl:w-[90%]'>
                                            <img className='absolute right-[50px] xl:right-0 top-[200px] xl:top-[-20px] h-[200px] xl:h-auto ' src={thank_you_boy} alt="thank you boy image" />
                                        </div>
                                    </div>
                                </div>


                            </div>

                        </div>
                    </div>
                )
            }


        </div>
    )
}

export default Contact